'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.create = create;
exports.all = all;
exports.get = get;
exports.update = update;
exports.updateGroup = updateGroup;
exports.remove = remove;
exports.uploadImage = uploadImage;

var _quCheck = require('../utils/qu-check');

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  create: create,
  all: all,
  get: get,
  update: update,
  updateGroup: updateGroup,
  remove: remove,
  uploadImage: uploadImage

  /**
   * Add item to an order
   * @param {Object} attrs - Attributes
   * @param {string} [attrs.jobId] - order number associated with the job
   * @param {number} [attrs.orderId] - id of the order associated with the job
   * @param {Object} Item - item model
   * @param {string} [attrs.item.name] - name of the item
   * @param {number} [attrs.item.quantity] - quantity of the item (min 1)
   * @returns {promise} containing the entity object of order
   */
};
function create() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      orderNumber = attrs.orderNumber,
      orderId = attrs.orderId,
      name = attrs.name,
      quantity = attrs.quantity;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _quCheck.checker.warn(_quCheck.checker.number, orderId);
  _quCheck.checker.warn(_quCheck.checker.string, name);

  return _http2.default.post('/customer/jobs/' + (jobId || orderNumber) + '/orders/' + orderId + '/items', { name: name, quantity: quantity }).then(function (item) {
    return _modelProvider2.default.Item(item, { jobId: jobId, orderId: orderId });
  });
}

function all() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      orderId = attrs.orderId;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _quCheck.checker.warn(_quCheck.checker.number, orderId);

  return _http2.default.get('/customer/jobs/' + jobId + '/orders/' + orderId + '/items').then(function (results) {
    return results.map(function (item) {
      return _modelProvider2.default.Item(item, { jobId: jobId, orderId: orderId });
    });
  });
}

function get() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = attrs.id,
      jobId = attrs.jobId,
      orderId = attrs.orderId;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _quCheck.checker.warn(_quCheck.checker.number, orderId);
  _quCheck.checker.warn(_quCheck.checker.number, id);

  return _http2.default.get('/customer/jobs/' + jobId + '/orders/' + orderId + '/items/' + id).then(function (item) {
    return _modelProvider2.default.Item(item, { jobId: jobId, orderId: orderId });
  });
}

function update() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = attrs.id,
      jobId = attrs.jobId,
      orderId = attrs.orderId,
      rest = (0, _objectWithoutProperties3.default)(attrs, ['id', 'jobId', 'orderId']);

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _quCheck.checker.warn(_quCheck.checker.number, orderId);
  _quCheck.checker.warn(_quCheck.checker.number, id);

  return _http2.default.put('/customer/jobs/' + jobId + '/orders/' + orderId + '/items/' + id, (0, _extends3.default)({}, rest)).then(function (item) {
    return _modelProvider2.default.Item(item, { jobId: jobId, orderId: orderId });
  });
}

function updateGroup() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return _promise2.default.all(items.map(function (item) {
    if (item.id && item.quantity > 0) return update(item);
    if (item.id && item.quantity === 0) return remove(item);
    return create(item);
  }));
}

function remove() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = attrs.id,
      jobId = attrs.jobId,
      orderId = attrs.orderId;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _quCheck.checker.warn(_quCheck.checker.number, orderId);
  _quCheck.checker.warn(_quCheck.checker.number, id);

  return _http2.default.remove('/customer/jobs/' + jobId + '/orders/' + orderId + '/items/' + id);
}

function uploadImage(itemId, file) {
  var byteString = void 0;
  if (file.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(file.split(',')[1]);
  } else {
    byteString = unescape(file.split(',')[1]);
  }

  var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
  var byteArray = new Uint8Array(byteString.length);
  var encodedbyteArray = byteArray.map(function (byte, index) {
    return byteString.charCodeAt(index);
  });

  var blob = new Blob([encodedbyteArray], { type: mimeString });

  var formData = new FormData();
  formData.append('file', blob, 'filename.jpg');

  return _http2.default.post('/customer/items/' + itemId + '/image', formData, true);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/items.js
// module id = 428
// module chunks = 0